import { useEffect } from 'react';
import styles from './PrivacyConsentPopup.module.scss';

interface PrivacyConsentProps {
	onClose: () => void;
}

const PrivacyConsent = ({ onClose }: PrivacyConsentProps) => {
	useEffect(() => {
		const html = document.documentElement;
		const body = document.body;
		html.style.overflow = 'hidden';
		body.style.overflow = 'hidden';

		return () => {
			html.style.overflow = '';
			body.style.overflow = '';
		};
	}, []);

	return (
		<div className={styles.overlay} onClick={onClose}>
			<div className={styles['popup-wrap']} onClick={e => e.stopPropagation()}>
				<button type="button" className={styles['popup-wrap__close']} onClick={onClose}></button>
				<div className={styles.popup}>
					<div className={styles['popup__title']}>
						<p>개인정보 수집 및 이용 동의</p>
					</div>
					<div className={styles['popup__content']}>
						<div className={`${styles['table']} table table-col`}>
							<table>
								<thead>
									<tr>
										<th>수집 및 이용목적</th>
										<th>수집하는 개인정보 항목</th>
										<th>보유 및 이용 기간</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="bullet-dash">
											<p className="bullet">상담 접수 및 처리</p>
											<p className="bullet">문의 응대 및 정보제공</p>
										</td>
										<td className="bullet-dash">
											<p className="bullet">
												회사명, 이름, 연락처,
												<br />
												이메일
											</p>
										</td>
										<td className="bullet-dash">
											<p className="bullet">
												동의일로부터 1년
												<br />
												(단, 요청 시 삭제)
											</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div className="button-group align-center">
							<button id="consultInquiryPsBtn" className={`${styles['submit-btn']} btn`} onClick={onClose}>
								확인
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PrivacyConsent;
